import gql from "graphql-tag";

export const APPROVE_MODERATION_OPTIONS_MUTATION = gql`
  mutation ApproveModerationOptions($input: ApproveModerationOptionsInput!) {
    success: approveModerationOptions(input: $input)
  }
`;

export {
  ApproveModerationOptions,
  ApproveModerationOptionsVariables,
  ApproveModerationOptionsInput as IApproveModerationOptionsInput
} from "~/graphql/types";



// WEBPACK FOOTER //
// ./src/graphql/mutations/optionApproval/approveModerationOptions.ts